import { render } from "./AboutView.vue?vue&type=template&id=4013bb0c&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=4013bb0c&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4013bb0c"]])

export default __exports__